// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"CI-z","carouselContainer":"DI-z"};